import { Outlet, RouteObject } from 'react-router-dom';
import { loadable } from '@sib/ui';
import { paths } from '@spendbrain/config/paths';

const ticketsPage = loadable(() => import('./pages/TicketsPage'));

export const routes: RouteObject[] = [
  {
    path: paths.tickets.employee.root,
    element: ticketsPage,
    children: [
      { path: paths.tickets.employee.children.tab, element: <Outlet /> },
      { path: paths.tickets.employee.children.new, element: <Outlet /> },
      { path: paths.tickets.employee.children.details, element: <Outlet /> },
      {
        path: paths.tickets.employee.children.detailsWithTab,
        element: <Outlet />,
      },
    ],
  },
  {
    path: paths.tickets.client.root,
    element: ticketsPage,
    children: [
      { path: paths.tickets.client.children.tab, element: <Outlet /> },
      { path: paths.tickets.client.children.new, element: <Outlet /> },
      { path: paths.tickets.client.children.details, element: <Outlet /> },
      {
        path: paths.tickets.client.children.detailsWithTab,
        element: <Outlet />,
      },
    ],
  },
];
